import React from "react";
import { Box, Typography } from "@mui/material";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";

const iconStyle = { mr: 1, color: "#B0B0B0" };

const ProductFeaturesSection = () => {
  return (
    <Box
      sx={{
        marginY: 3,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: 2, sm: 8 },
      }}>
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <StarOutlineIcon sx={iconStyle} />
          <Typography fontSize="0.95rem">Prepared by Experts</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <LocalShippingOutlinedIcon sx={iconStyle} />
          <Typography fontSize="0.95rem">On-time delivery</Typography>
        </Box>
      </Box>

      <Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <CardGiftcardOutlinedIcon sx={iconStyle} />
          <Typography fontSize="0.95rem">Gift Packaging Available</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <VerifiedOutlinedIcon sx={iconStyle} />
          <Typography fontSize="0.95rem">Satisfaction Guaranteed</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductFeaturesSection;
